import * as React from "react"
import * as ReactDOM from "react-dom"
import { Moment } from 'moment';
import * as moment from 'moment';

import { RentalAdvertPricing, Room } from '../../../types/types'

import Summary from '../../../advert_detail/booking_form/mobile/summary'
import BnbPeriodAndRoomSelection from '../../../advert_detail/booking_form/mobile/bnb_period_and_room_selection'
import BnbRoomSelection from '../../../advert_detail/booking_form/mobile/bnb_room_selection'
import { StartEnd } from '../../../utils/period_picker/PeriodPicker'
import * as RoomEventEmitter from '../../../utils/period_picker/RoomEventEmitter'

import * as Api from '../../../api/fetch'

import { FocusedInputShape } from 'react-dates';


type Props = {
  advert_id: number
  arrival_date: Moment
  departure_date: Moment
  max_people_select: number
  rooms: Room[]
  source: string
  max_people: string
}

type State = {
  pricing: RentalAdvertPricing
  period_open: boolean
  arrival_date: Moment
  departure_date: Moment
  max_people: number
  room_id: number
  focusedInput: FocusedInputShape
}

export default class MobilePeriodSelection extends React.Component<Props, State> {
  subscriptionToken : string
  constructor(props : Props, context) {
    super(props, context)
    this.state = {
      pricing: null,
      period_open: false,
      arrival_date: this.props.arrival_date ? moment(this.props.arrival_date, "DD-MM-YYYY") : null,
      departure_date: this.props.departure_date ? moment(this.props.departure_date,   "DD-MM-YYYY") : null,
      max_people: parseInt(this.props.max_people) || 1,
      room_id: null,
      focusedInput: null,
    }
  }

  async refresh() {
    const pricing = await Api.fetchPricing(this.props.advert_id, this.state.arrival_date, this.state.departure_date, this.state.max_people, this.state.room_id)
    this.setState({
      ...this.state,
      pricing: pricing
    })
  }

  componentWillMount() {
    this.subscriptionToken = RoomEventEmitter.subscribe((payload: RoomEventEmitter.EventPayload) => {
      if (payload.room_id != this.state.room_id) {
        this.setState({ room_id: payload.room_id })
      }
    })
  }

  componentWillUnmount() {
    RoomEventEmitter.unsubscribe(this.subscriptionToken)
  }

  componentDidMount() {
    this.refresh()
  }

  componentDidUpdate(prevProps : Props, prevState : State) {
    if (this.shouldRefreshPricing(prevProps, prevState)) {
      this.refresh()
    }
  }

  shouldRefreshPricing(prevProps : Props, prevState : State) {
    return (
      prevProps.advert_id !== this.props.advert_id ||
      prevState.arrival_date !== this.state.arrival_date ||
      prevState.departure_date !== this.state.departure_date ||
      prevState.max_people !== this.state.max_people ||
      prevState.room_id !== this.state.room_id
    )
  }

  togglePeriodSelection() {
    this.setState({...this.state, period_open: !this.state.period_open })
  }

  render() {
    return (
      <div className="conversion-box">
        <div className={`conversion-box__period-selection-bnb ${this.state.period_open ? '' : 'closed'}`}>
          <button className="conversion-box__close" onClick={() => this.togglePeriodSelection()}>
            <span className="icon-cross"></span>
          </button>

          <BnbPeriodAndRoomSelection
            arrival_date={this.state.arrival_date}
            departure_date={this.state.departure_date}
            room_id={this.state.room_id}
            onDatesChange={(range: StartEnd) => this.setState({ arrival_date: range.startDate, departure_date: range.endDate })}
            max_people_select={this.props.max_people_select}
            max_people={this.state.max_people}
            onMaxPeopleChange={(value:number) => this.setState({ max_people: value})}
            focusedInput={this.state.focusedInput}
            onFocusChange={(fi) => this.setState({focusedInput: fi})}
            pricing={this.state.pricing}
            onRoomChange={(value:number) => this.setState({ room_id: value})}
            rooms={this.props.rooms}
            source={this.props.source}
            closeScreen={() => this.togglePeriodSelection()}
          />
        </div>
        <Summary
          pricing={this.state.pricing}
          onPriceClick={() => this.togglePeriodSelection()}
        />
      </div>
    )
  }
}
